// extracted by mini-css-extract-plugin
export default {"container":"About_container__A9Od7","about-title":"About_about-title__alNer","about-description":"About_about-description__-uTZr"};